import { Amount } from '@ui/components/Amount/Amount';
import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { usePayTokenPriceLatest } from '@ui/features/Trade/hooks/usePayTokenPriceLatest';
import { usePayTokenBalance } from '@ui/hooks/usePayTokenBalance';
import { Text } from '@ui/lib/park/ui/text';
import { PayablePoolToken } from '@ui/types/token';
import { Flex, HStack, HstackProps, styled } from 'styled-system/jsx';

export const TokenOption = ({
  token,
  ...props
}: { token: PayablePoolToken } & HstackProps) => {
  const balance = usePayTokenBalance(token);
  const price = usePayTokenPriceLatest(token);

  return (
    <HStack
      gap="16"
      w="full"
      justifyContent="space-between"
      alignItems="flex-start"
      h="37px"
      {...props}
      data-cy={`TokenOption-${token.displaySymbol}`}
    >
      <HStack gap="8px">
        <styled.img
          src={token.image}
          alt="token icon"
          width="16px"
          height="16px"
        />
        <Text textStyle="headings.default">{token.displaySymbol}</Text>
      </HStack>
      <Flex
        flexDir="column"
        justifyContent="flex-end"
        textAlign="right"
        gap="4px"
      >
        {balance && (
          <Amount
            textStyle="numbers.default"
            color="v2.text.primary"
            value={balance}
            data-cy={`TokenBalance-${token.displaySymbol}`}
            data-cy-value={balance}
          />
        )}

        {price && balance && (
          <AmountUsd
            textStyle="numbers.xsmall"
            color="v2.text.subtle"
            value={price?.times(balance)}
            opts={{
              prefix: '~$',
            }}
          />
        )}
      </Flex>
    </HStack>
  );
};
